export default __webpack_public_path__ + "static/media/picket-fence-back.2ca65a69.png";